import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Booking from "@/components/Booking";
import Reviews from "@/components/Reviews";
import About from "@/components/About";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";

export default function Landing() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50 bg-grain" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <Booking />
        <Reviews />
        <About />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
